import React from 'react'
import SearchFilter from './search-filter'
import { get } from 'lodash'

const FacilitatorFilter = ({
    value = '',
    onChange = () => {},
    disabled
}) => {
    return (
        <SearchFilter
            title='Facilitator'
            value={get(value, 'facilitator')}
            onChange={v => onChange({ ...value, facilitator: v})}
            disabled={disabled}
        />
    )
}

export default FacilitatorFilter